import React, { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

import {
    Container, Grid, Box, Button, Typography, Dialog,
    DialogTitle, DialogContent, DialogActions, Divider,
    Tooltip, Rating
} from '@mui/material';

import AOS from 'aos';
import "aos/dist/aos.css";

import Watermark from '@uiw/react-watermark';

import Lightbox from "yet-another-react-lightbox";
import Inline from "yet-another-react-lightbox/plugins/inline";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import { LazyLoadImage } from 'react-lazy-load-image-component';

import ViewInArIcon from '@mui/icons-material/ViewInAr';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import FormatShapesIcon from '@mui/icons-material/FormatShapes';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';

import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";

import {
    StyledButton, StyledButton2, StyledRowTextImg2, StyledSubtitle
} from './StyledComponents';

import useWindowDimensions from './useWindowDimensions';

import { impresionData, tecladosData, membranasData, refaccionesData, ruedasData, amortiguadoresData, shuffled } from '../../utils/productos';
import CatalogItem from './CatalogItem';

const Products = () => {

    const location = useLocation();

    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);
    const [carouselAspectRatio, setCarouselAspectRatio] = useState("3/1");
    const [category, setCategory] = useState(shuffled);
    const [title, setTitle] = useState('Productos destacados');
    const [currentProduct, setCurrentProduct] = useState({ nombre: 'product' });
    const [viewDetails, setViewDetails] = useState(false);

    const aspectRatio = useWindowDimensions();

    let state = location.state;
    let cat = state ? state.cat : null;

    const toggleOpen = (state) => () => setOpen(state);

    const updateIndex = ({ index: current }) => setIndex(current);

    const slides = [
        {
            type: "custom-slide",
            bg: "./images/productos/banner_3.png",
            src: "./images/productos/g1.png",
            title: 'Impresión 3D',
            description: <Typography variant='h5' sx={{ color: '#000', px: 5 }}>Desde <span style={{ fontWeight: "bold", color: "#f40040cc" }}>refacciones industriales</span> hasta piezas personalizadas para <span style={{ fontWeight: "bold", color: "#f40040cc" }}>dispositivos médicos</span>.</Typography>,
            comp: <Typography variant='subtitle1' sx={{ color: '#000', mt: 2, mb: 5 }}>Contamos con impresoras 3D de última generación que nos permiten fabricar piezas de precisión rápidamente.</Typography>,
            fn: () => setCategory(impresionData)
        },
        {
            type: "custom-slide",
            bg: "./images/productos/banner_2.png",
            src: "./images/membranas/explosive-keyboard.png",
            title: 'Teclados de membrana',
            description: <Typography variant='h5' sx={{ color: '#000', px: 5 }}>Teclados fabricados con materiales de <span style={{ fontWeight: "bold", color: "#f40040cc" }}>alta calidad y tecnología</span>.</Typography>,
            comp: <Typography variant='subtitle1' sx={{ color: '#000', mt: 2, mb: 5, px: 3 }}>Ideales para equipos médicos, instrumentación industrial, electrodomésticos y sistemas de control.</Typography>,
            fn: () => setCategory(membranasData)
        },
        {
            type: "custom-slide",
            bg: "./images/productos/banner.jpg",
            src: "./images/productos/ruedas_img.png",
            title: 'Ruedas y rodajas',
            description: <Typography variant='h5' sx={{ color: '#000', px: 5 }}>Juvalfri te ofrece <span style={{ fontWeight: "bold", color: "#f40040cc" }}>ruedas</span> y <span style={{ fontWeight: "bold", color: "#f40040cc" }}>rodajas</span> para la <span style={{ fontWeight: "bold", color: "#f40040cc" }}>movilidad hospitalaria</span>.</Typography>,
            comp: <Typography variant='subtitle1' sx={{ color: '#000', mt: 2, mb: 5, px: 3 }}>Nuestras ruedas destacan por su durabilidad, maniobrabilidad y resistencia, asegurando un rendimiento de alta calidad en hospitales.</Typography>,
            fn: () => setCategory(ruedasData)
        },
        {
            type: "custom-slide",
            bg: "./images/productos/banner_4.png",
            src: "./images/productos/shock_img.png",
            title: 'Amortiguadores',
            description: <Typography variant='h5' sx={{ color: '#000', px: 5 }}><span style={{ fontWeight: "bold", color: "#f40040cc" }}>Amortiguadores de bloqueo de gas</span> para cada situación de montaje y necesidad particular</Typography>,
            comp: <Typography variant='subtitle1' sx={{ color: '#000', mt: 2, mb: 5, px: 3 }}>Los amortiguadores de gas bloqueables pueden bloquearse de forma continua y  de manera firme o amortiguada en tracción o compresión.</Typography>,
            fn: () => setCategory(amortiguadoresData)
        },
    ];

    const manufacturaData = refaccionesData.concat(impresionData);

    useEffect(() => {
        AOS.init({ duration: 400 });
        document.title = "Productos";

        document.body.style.backgroundColor = '#1B2133';
        window.scrollTo({ top: 0, behavior: 'smooth' })
        const handleContextmenu = e => {
            e.preventDefault();
        };
        document.addEventListener('contextmenu', handleContextmenu);
        return () => {
            document.body.style.backgroundColor = '#0d1117';
            document.removeEventListener('contextmenu', handleContextmenu);
            window.history.replaceState({}, '');
        };
    }, []);

    useEffect(() => {
        if (cat) {
            switch (cat) {
                case 'impresion':
                    setCategory(impresionData);
                    break;
                case 'teclados':
                    setCategory(tecladosData);
                    break;
                case 'membranas':
                    setCategory(membranasData);
                    break;
                case 'refacciones':
                    setCategory(manufacturaData);
                    break;
                case 'ruedas':
                    setCategory(ruedasData);
                    break;
                case 'amortiguadores':
                    setCategory(amortiguadoresData);
                    break;
                case 'destacados':
                    setCategory(shuffled);
                    break;
                default:
                    setCategory(shuffled);
                    break;
            }
        } else {
            setCategory(shuffled);
        }
    }, [cat]);

    useEffect(() => {
        switch (category[0].categoria) {
            case impresionData[0].categoria:
                setTitle('Impresión 3D');
                break;
            case tecladosData[0].categoria:
                setTitle('Teclados de membrana');
                break;
            case membranasData[0].categoria:
                setTitle('Membranas (Overlay)');
                break;
            case manufacturaData[0].categoria:
                setTitle('Refacciones y piezas');
                break;
            case ruedasData[0].categoria:
                setTitle('Ruedas y rodajas');
                break;
            case amortiguadoresData[0].categoria:
                setTitle('Amortiguadores');
                break;
            case shuffled[0].categoria:
                setTitle('Productos destacados');
            default:
                setTitle('Productos destacados');
                break;
        }
    }, [category]);

    useEffect(() => {
        let tmpAspectRatio = "3/1";
        if (aspectRatio < 0.40) {
            tmpAspectRatio = "1/3";
        } else if (aspectRatio < 0.45) {
            tmpAspectRatio = "1/2.5";
        } else if (aspectRatio < 0.7) {
            tmpAspectRatio = "1/2";
        } else if (aspectRatio < 0.93) {
            tmpAspectRatio = "1.5/2";
        } else if (aspectRatio < 1) {
            tmpAspectRatio = "2/2";
        } else if (aspectRatio < 1.3) {
            tmpAspectRatio = "2/1";
        } else if (aspectRatio < 1.5) {
            tmpAspectRatio = "3/1";
        } else if (aspectRatio < 1.7) {
            tmpAspectRatio = "3/1";
        } else if (aspectRatio < 1.9) {
            tmpAspectRatio = "4/1";
        }
        setCarouselAspectRatio(tmpAspectRatio);
    }, [aspectRatio]);

    const renderBanner = useMemo(() => (
        <Box sx={{ display: 'flex', borderRadius: '32px', overflow: 'hidden' }}>
            <Lightbox
                index={index}
                plugins={[Inline, Slideshow]}
                slideshow={{
                    autoplay: true,
                    delay: 6000,
                }}
                on={{
                    view: updateIndex,
                    click: toggleOpen(true),
                }}
                carousel={{
                    padding: 0,
                    spacing: 0,
                    imageFit: "cover",
                }}
                inline={{
                    style: {
                        width: "100%",
                        height: '100%',
                        aspectRatio: carouselAspectRatio, // Se actualiza automáticamente
                        margin: "0px",
                    },
                }}
                slides={slides}
                render={{
                    slide: ({ slide }) =>
                        slide.type === "custom-slide" ? (
                            <Box className='' sx={{ background: `url(${slide.bg}) no-repeat center center`, backgroundSize: 'cover', height: '100%', width: '100%', position: 'relative' }}>
                                <Box sx={{ borderRadius: '20px', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center', width: '100%', padding: '20px' }}>
                                    <Grid container sx={{ width: '100%' }}>
                                        <Grid item md={8} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                            <Typography variant='h3' sx={{ fontWeight: 'bold', color: '#000', mb: 5 }}>{slide.title}</Typography>
                                            {slide.description}
                                            {slide.comp}
                                            <StyledButton onClick={slide.fn}>Ver Productos</StyledButton>
                                        </Grid>
                                        <Grid item md={4} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <img alt={slide.title} src={slide.src} style={{ width: '80%', height: 'auto', marginTop: '20px', alignItems: 'center' }} />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>
                        ) : null,
                }}
            />
        </Box>
    ), [carouselAspectRatio, index, slides]);

    const handleOpenDetails = (product) => {
        setCurrentProduct(product)
        setViewDetails(true)
    }

    const handleCloseDetails = () => {
        setCurrentProduct({ nombre: 'product' })
        setViewDetails(false)
    }

    const renderDetails = useMemo(() => (
        <Dialog
            open={viewDetails} // updated to use setViewDetails state
            onClose={() => handleCloseDetails()}
            fullWidth={true}
            maxWidth={'xl'}
            scroll='paper'
        >
            <DialogTitle >Detalles del producto</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '6px 0px' }}>
                    <Box sx={{ mt: 2, mb: 5 }}>
                        <Typography style={{ fontWeight: 700 }} variant="h5" component="div">
                            {currentProduct.nombre}
                        </Typography>
                    </Box>

                    <Container>
                        <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Grid item xs={12} sm={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Box sx={{ width: '90%', height: '90%', display: 'flex', justifyContent: 'center', alignItems: 'center', my: 1 }}>
                                    <Watermark
                                        height={57}
                                        width={200}
                                        offsetLeft={-1}
                                        image="./images/Juvalfri-watermark.svg"
                                    >
                                        <LazyLoadImage style={{ padding: '12px', width: '100%', objectFit: 'contain', height: '100%', borderRadius: '10px', backgroundColor: '#fff' }} src={currentProduct.imagen} alt={currentProduct.nombre} />
                                    </Watermark>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} sx={{ display: 'flex', justifyContent: 'center', alignContent: 'space-arround', flexDirection: 'column', alignItems: 'stretch' }}>
                                <Box>
                                    <Divider variant="middle" sx={{ width: '100%', mb: 1 }} />
                                    <Typography variant="h6" sx={{ p: 1 }}>
                                        {currentProduct.descripcion}
                                    </Typography>
                                    <Rating
                                        name="simple-uncontrolled"
                                        defaultValue={5}
                                    />
                                    <Divider variant="middle" sx={{ width: '100%', my: 1 }} />
                                </Box>
                                <Box sx={{ mt: 5 }}>
                                    <Typography variant="body1" sx={{ p: 1 }}>
                                        Para conocer mas detalles sobre este producto, por favor contacta a nuestro equipo de ventas.
                                    </Typography>
                                </Box>
                                <Box>
                                    <Link to='https://wa.me/message/7XOWX4XGRUGWO1' target="_blank" style={{ textDecoration: 'none', color: 'inherit' }}>
                                        <Tooltip title='Iniciar Chat' placement='bottom' arrow>
                                            <div style={{ display: 'flex', flexDirection: 'row' }} className='whatsLink-f'>
                                                <p style={{ textAlign: 'start', fontWeight: '400', fontSize: '13px', padding: '0px 16px 0px 16px', marginBottom: '0px' }}>
                                                    <WhatsAppIcon fontSize='medium' />
                                                </p>
                                                <p style={{ textAlign: 'start', fontWeight: '400', fontSize: '15px', marginBottom: '0px' }}>
                                                    55-48-61-73-32
                                                </p>
                                            </div>
                                        </Tooltip>
                                    </Link>
                                </Box>
                            </Grid>
                        </Grid>
                    </Container>




                </Box>
            </DialogContent>
            <DialogActions>
                <Button color='warning' variant='contained' onClick={() => handleCloseDetails()}>Cerrar &nbsp; <i className="fad fa-times"></i></Button>
            </DialogActions>
        </Dialog>
    ), [currentProduct, viewDetails]);

    return (
        <>
            <h1 style={{ display: 'none' }}>Productos</h1>

            <Container maxWidth="xl" sx={{ mt: 4 }} data-aos='fade-up'>
                {renderBanner}
            </Container>

            <Container maxWidth="xl" sx={{ my: 4 }}>
                <Typography variant="h4" sx={{ my: 3 }} gutterBottom data-aos='fade-up'>Explorar por categoria</Typography>
                <Grid container spacing={3} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} data-aos='fade-up'>
                    <Grid item xs={12} sm={6} md={3} lg={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Box component={StyledButton2} onClick={() => setCategory(impresionData)} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px', flexDirection: 'column', boxShadow: '0px 0px 10px #0d1117', borderRadius: '20px', maxWidth: '300px', width: '100%', height: '148px', backgroundColor: '#f5f5f522' }}>
                            <p><ViewInArIcon fontSize='large' style={{ transform: 'scale(1.2)' }} /></p>
                            <Typography variant='h6'>Impresión 3D</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Box component={StyledButton2} onClick={() => setCategory(tecladosData)} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px', flexDirection: 'column', boxShadow: '0px 0px 10px #0d1117', borderRadius: '20px', maxWidth: '300px', width: '100%', height: '148px', backgroundColor: '#f5f5f522' }}>
                            <p><KeyboardIcon fontSize='large' style={{ transform: 'scale(1.2)' }} /></p>
                            <Typography variant='h6'>Teclados de membrana</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Box component={StyledButton2} onClick={() => setCategory(membranasData)} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px', flexDirection: 'column', boxShadow: '0px 0px 10px #0d1117', borderRadius: '20px', maxWidth: '300px', width: '100%', height: '148px', backgroundColor: '#f5f5f522' }}>
                            <p><FormatShapesIcon fontSize='large' style={{ transform: 'scale(1.2)' }} /></p>
                            <Typography variant='h6'>Membranas (Overlay)</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Box component={StyledButton2} onClick={() => setCategory(manufacturaData)} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px', flexDirection: 'column', boxShadow: '0px 0px 10px #0d1117', borderRadius: '20px', maxWidth: '300px', width: '100%', height: '148px', backgroundColor: '#f5f5f522' }}>
                            <p><BuildCircleIcon fontSize='large' style={{ transform: 'scale(1.2)' }} /></p>
                            <Typography variant='h6'>Refacciones y piezas</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Box component={StyledButton2} onClick={() => setCategory(ruedasData)} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px', flexDirection: 'column', boxShadow: '0px 0px 10px #0d1117', borderRadius: '20px', maxWidth: '300px', width: '100%', height: '148px', backgroundColor: '#f5f5f522' }}>
                            <img src='./images/productos/caster_icon.svg' alt='img' style={{ width: '42px', marginBottom: '18px' }} />
                            <Typography variant='h6'>Ruedas y rodajas</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Box component={StyledButton2} onClick={() => setCategory(amortiguadoresData)} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px', flexDirection: 'column', boxShadow: '0px 0px 10px #0d1117', borderRadius: '20px', maxWidth: '300px', width: '100%', height: '148px', backgroundColor: '#f5f5f522' }}>
                            <img src='./images/productos/shock_icon.svg' alt='img' style={{ width: '42px', marginBottom: '18px' }} />
                            <Typography variant='h6'>Amortiguadores</Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container>

            <Container maxWidth="xl" sx={{ my: 5 }}>
                <Typography variant="h4" gutterBottom>{title}</Typography>
                <Grid container spacing={5}>
                    {category.map((product, index) => (
                        // <Grid item xs={12} sm={6} md={3} xl={2} key={product._id.$oid} sx={{ display: 'flex', padding: '10px', flexDirection: 'column', justifyContent: 'space-between' }}>
                        //     <Box sx={{ width: '100%', height: '100%', maxHeight: '250px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        //         {product.imagen ? <LazyLoadImage src={product.imagen} alt={product.nombre} style={{ padding: '12px', width: '100%', objectFit: 'contain', height: '100%', borderRadius: '10px', backgroundColor: '#fff' }} /> : <ImageNotSupportedIcon style={{ color: '#000', width: '100%', height: '100%', borderRadius: '10px', border: '1px solid #ccc', backgroundColor: '#fff' }} />}
                        //     </Box>
                        //     <Box>
                        //         <Typography variant='h6'>{product.nombre}</Typography>
                        //         <Typography sx={{ color: '#ccd' }}>{product.descripcion}</Typography>
                        //     </Box>
                        // </Grid>
                        <Grid item key={product._id.$oid} xs={12} sm={6} md={4} xl={3}>
                            <CatalogItem
                                name={product.nombre}
                                image={product.imagen}
                                info={product.descripcion}
                                color={'primary.main'}
                                btnColor={'primary'}
                                onClick={() => handleOpenDetails(product)}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Container>

            <Container maxWidth="xl" sx={{ mt: 5 }}>
                <StyledRowTextImg2>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={10} lg={10} xl={10} >
                            <StyledSubtitle>
                                ¿Tienes dudas sobre nuestros <span>productos</span> o <span>servicios</span>? 📩 Contáctanos para <span>asesoría</span>, <span>cotizaciones</span> u <span>ofertas</span>. ¡Estamos para ayudarte! 💡✅
                            </StyledSubtitle>
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2} className='img-container'>
                            <div style={{ display: 'flex', alignItems: 'end', justifyContent: 'center' }}>
                                <div style={{ maxWidth: '100px', maxHeight: '100px', borderRadius: '50%', background: 'radial-gradient(227.48% 373.86% at 50% 220.45%, #c178e6 31.77%, #0fb6db 100%)' }}>
                                    <img src='./images/icon-users-2.svg' alt='img' style={{ width: '100%' }}></img>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} className='img-container'>
                            <div style={{ display: 'flex', alignItems: 'end', justifyContent: 'center' }}>
                                <Link to='/contacto' style={{ textDecoration: 'none' }}>
                                    <StyledButton2 >Contacto</StyledButton2>
                                </Link>
                            </div>
                        </Grid>
                    </Grid>
                </StyledRowTextImg2>
            </Container>
            <Container maxWidth='xxl' style={{ paddingLeft: '0px', paddingRight: '0px', background: 'linear-gradient(180deg, #1B2133 30%, #171726 100%)', paddingBottom: '120px' }}>

            </Container>
            {renderDetails}
        </>
    )

}

export default Products;